import { IIconBase } from '..'

const arrowUpIcon = ({
  color = '#333752',
  height = 17,
  width = 16,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2.71976 11.2004L7.06645 6.85379C7.57978 6.34039 8.41978 6.34039 8.93311 6.85379L13.2798 11.2004'
        stroke={color}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default arrowUpIcon
